import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useLivePanchang } from "@/lib/usePanchang";
import { Sparkles, ArrowRight } from "lucide-react";

// Slim, always-visible "Today" bar at the very top of the homepage — a quick
// glance at today's Tithi · Nakshatra · Vara with a link to the full Panchangam.
// Data comes from the SAME live engine payload as HomePanchang / the full page.
export default function TodayStrip() {
  const { pick } = useLang();
  const { data } = useLivePanchang();
  if (!data) return null;

  const items = [
    { label: pick("तिथि", "Tithi"), value: `${pick(data.paksha?.deva, data.paksha?.en) || ""} ${pick(data.tithi?.deva, data.tithi?.en) || ""}`.trim() },
    { label: pick("नक्षत्र", "Nakshatra"), value: pick(data.nakshatra?.deva, data.nakshatra?.en) },
    { label: pick("वार", "Vara"), value: pick(data.vara?.deva, data.vara?.en) },
  ].filter((i) => i.value);

  if (!items.length) return null;

  return (
    <div data-testid="home-today-strip" className="border-b border-line bg-[var(--surface-alt)]">
      <div className="mx-auto flex max-w-7xl items-center gap-2.5 px-5 py-2 md:gap-4 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-saffron">
          <Sparkles className="h-3.5 w-3.5" /> <span className="hidden sm:inline">{pick("आज", "Today")}</span>
        </span>
        <div className="flex min-w-0 flex-1 items-center gap-x-2.5 overflow-x-auto md:gap-x-5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {items.map((it) => (
            <span key={it.label} className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-[13px] text-ink-2 md:text-sm">
              <span className="hidden text-[11px] uppercase tracking-wide text-ink-3 md:inline">{it.label}</span>
              <span className="font-medium text-ink">{it.value}</span>
            </span>
          ))}
        </div>
        <Link to="/panchang" data-testid="today-strip-full" aria-label={pick("पूर्ण पंचांग", "Full Panchangam")} className="ml-auto inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-[13px] text-saffron transition-transform hover:translate-x-0.5 md:text-sm">
          <span className="hidden md:inline">{pick("पूर्ण पंचांग", "Full Panchangam")}</span>
          <span className="hidden sm:inline md:hidden">{pick("पंचांग", "Panchangam")}</span>
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
}
